import { Injectable, Injector, Inject } from "@angular/core";
import { NgxsNextPluginFn, NgxsPlugin, getActionTypeFromInstance } from "@ngxs/store";
import { PersistAppState, RestoreAppState } from "src/app/state/app.actions";
import { StateStorageService } from "../state-storage.service";

export const NGXS_STORE_STATE_KEY = 'IAC-Store-State';

@Injectable()
export class PesistStateOnPageRefreshPlugin implements NgxsPlugin {
    private readonly default = { router: { url: '/' } };

    constructor(@Inject(Injector) private readonly _injector: Injector) { }

    // Add private "Lazy" getters
    private _stateStorage: StateStorageService;
    private get stateStorage(): StateStorageService {
        if (!this._stateStorage) { this._stateStorage = this._injector.get(StateStorageService); }
        return this._stateStorage;
    }

    handle(state: any, action: any, next: NgxsNextPluginFn) {
        const actionType = getActionTypeFromInstance(action);

        if (actionType === RestoreAppState.type) {
            const storeState = {
                ...this.default,
                ...this.stateStorage.fetchState()
            };
            if (storeState.router.url === this.routeUrl) {
                state = {
                    ...state,
                    ...storeState.state
                };
            }
            this.stateStorage.clearState();
        } else if (actionType === PersistAppState.type && action.persist) {
            const storeState = {
                router: { url: this.routeUrl },
                state: { ...state }
            };
            this.stateStorage.persistState(storeState);
        }

        return next(state, action);
    }

    private get routeUrl() {
        return location.pathname + location.search;
    }
}
